import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/all-img/thumb.png'
import _imports_1 from '../../assets/img/icon/user.svg'
import _imports_2 from '../../assets/img/icon/file2.svg'
import _imports_3 from '../../assets/img/icon/clock.svg'
import _imports_4 from '../../assets/img/icon/star.svg'
import _imports_5 from '../../assets/img/icon/target.svg'
import _imports_6 from '../../assets/img/icon/web.svg'
import _imports_7 from '../../assets/img/icon/fb.svg'
import _imports_8 from '../../assets/img/icon/tw.svg'
import _imports_9 from '../../assets/img/icon/ins.svg'
import _imports_10 from '../../assets/img/icon/pn.svg'
import _imports_11 from '../../assets/img/all-img/rc-1.png'
import _imports_12 from '../../assets/img/all-img/rc-2.png'
import _imports_13 from '../../assets/img/all-img/rc-3.png'


const _hoisted_1 = { class: "single-course-sidebar" }
const _hoisted_2 = { class: "course-widget" }
const _hoisted_3 = { class: "course-video" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "image"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-play cr-video-btn" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"sidebar-content\"><h3>Free</h3><a href=\"#\" class=\"default-btn course-btn\">Enroll Now</a><ul class=\"courses-details\"><li><div class=\"icon\"><img src=\"" + _imports_1 + "\" alt=\"icon\"> Instructor </div><p>Daniel Smith</p></li><li><div class=\"icon\"><img src=\"" + _imports_2 + "\" alt=\"icon\"> Lectures </div><p>23</p></li><li><div class=\"icon\"><img src=\"" + _imports_3 + "\" alt=\"icon\"> Duration </div><p>2Hr 36Minutes</p></li><li><div class=\"icon\"><img src=\"" + _imports_4 + "\" alt=\"icon\"> Enrolled </div><p>2k Students</p></li><li><div class=\"icon\"><img src=\"" + _imports_5 + "\" alt=\"icon\"> Course level </div><p>Intermediate</p></li><li><div class=\"icon\"><img src=\"" + _imports_6 + "\" alt=\"icon\"> Language </div><p>English</p></li></ul><ul class=\"course-shared\"><li class=\"title\">Share On:</li><li><a href=\"#\"><img src=\"" + _imports_7 + "\" alt=\"icon\"></a></li><li><a href=\"#\"><img src=\"" + _imports_8 + "\" alt=\"icon\"></a></li><li><a href=\"#\"><img src=\"" + _imports_9 + "\" alt=\"icon\"></a></li><li><a href=\"#\"><img src=\"" + _imports_10 + "\" alt=\"icon\"></a></li></ul></div>", 1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"widget widget-resent-course\"><h3 class=\"widget-title\">Related Courses</h3><div class=\"item\"><a href=\"#\" class=\"thumb\"><img src=\"" + _imports_11 + "\" alt=\"iamge\"></a><ul><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star disstar\"></i></li><li><i class=\"bx bxs-star disstar\"></i></li></ul><div class=\"info\"><h4 class=\"title\"><a href=\"#\">Greatest Passion In...</a></h4><span>$38.00</span></div></div><div class=\"item\"><a href=\"#\" class=\"thumb\"><img src=\"" + _imports_12 + "\" alt=\"iamge\"></a><ul><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star disstar\"></i></li><li><i class=\"bx bxs-star disstar\"></i></li></ul><div class=\"info\"><h4 class=\"title\"><a href=\"#\">Greatest Passion In...</a></h4><span>$38.00</span></div></div><div class=\"item\"><a href=\"#\" class=\"thumb\"><img src=\"" + _imports_13 + "\" alt=\"iamge\"></a><ul><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star\"></i></li><li><i class=\"bx bxs-star disstar\"></i></li><li><i class=\"bx bxs-star disstar\"></i></li></ul><div class=\"info\"><h4 class=\"title\"><a href=\"#\">Greatest Passion In...</a></h4><span>$38.00</span></div></div></div>", 1)
const _hoisted_9 = {
  key: 0,
  class: "popup-video"
}
const _hoisted_10 = { class: "d-table" }
const _hoisted_11 = { class: "d-table-cell" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "play-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.youtube.com/embed/PWvPbGWVRrU",
    allowfullscreen: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "video-btn popup-youtube",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePopup && _ctx.togglePopup(...args))),
            style: {"cursor":"pointer"}
          }, _hoisted_6)
        ]),
        _hoisted_7
      ]),
      _hoisted_8
    ]),
    (_ctx.isPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "popup-overlay-close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePopup && _ctx.togglePopup(...args)))
              }, _hoisted_14),
              _hoisted_15
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}